import { Menu } from "@mantine/core";
import {
  HeldEmailRowAction,
  useHeldEmailRowAction,
} from "../../../hooks/admin/useHeldEmailRowAction";

interface Props {
  action: HeldEmailRowAction;
  heldEmailId: string;
  onAction: (ids: string[]) => void;
}
export function HeldEmailRowActionItem({
  action,
  heldEmailId,
  onAction,
}: Props) {
  const item = useHeldEmailRowAction(action, heldEmailId, onAction);
  const Icon = item.detail.icon;
  return (
    <Menu.Item
      color={action === "cancel" ? "red" : undefined}
      leftSection={<Icon size={16} />}
      onClick={item.handleClick}
    >
      {item.detail.label}
    </Menu.Item>
  );
}
